import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchServiceTemplates({ service_provider_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/new_schedule/fetch_service_templates/${service_provider_id}`
    );
  },
  fetchAgroExporters({ service_provider_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/new_schedule/fetch_agro_exporters/${service_provider_id}`
    );
  },
  create({ service_provider_id, scheduled_at, started_at, finished_at, status_id, observations, agro_exporter_id, service_templates }) {
    return RequesterV1.post(
      `service_provider/services/container_op/new_schedule/create/${service_provider_id}`,
      {
        container_scheduled_service: {
          scheduled_at,
          started_at,
          finished_at,
          status_id,
          observations,
          agro_exporter_id,
        },
        service_templates
      }
    );
  },
};
